function initKnowledgeBase(root) {
  if (!root || root.dataset.kbInitialized === 'true') return;
  root.dataset.kbInitialized = 'true';

  var input = root.querySelector('[data-kb-search]');
  var clearButton = root.querySelector('[data-kb-clear]');
  var resultCount = root.querySelector('[data-kb-result-count]');
  var categoriesSection = root.querySelector('.knowledge-base__section--categories');
  var latestSection = root.querySelector('.knowledge-base__section--latest');
  var searchResultsSection = root.querySelector('[data-kb-search-results]');
  var emptyState = root.querySelector('[data-kb-empty]');
  var searchableArticles = searchResultsSection
    ? Array.from(searchResultsSection.querySelectorAll('[data-kb-article]'))
    : [];
  var defaultCountText = resultCount ? resultCount.textContent : '';

  if (!input || !categoriesSection || !latestSection || !searchResultsSection || !searchableArticles.length) {
    return;
  }

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function toggle(el, show) {
    if (!el) return;
    el.hidden = !show;
    el.style.display = show ? '' : 'none';
  }

  function resetView() {
    toggle(categoriesSection, true);
    toggle(latestSection, true);
    toggle(searchResultsSection, false);
    toggle(emptyState, false);
    toggle(clearButton, false);

    searchableArticles.forEach(function (article) {
      toggle(article, true);
    });

    if (resultCount) {
      resultCount.textContent = defaultCountText;
    }
  }

  function applySearch() {
    var query = normalize(input.value);
    var matches = 0;

    if (!query) {
      resetView();
      return;
    }

    toggle(categoriesSection, false);
    toggle(latestSection, false);
    toggle(searchResultsSection, true);
    toggle(clearButton, true);

    searchableArticles.forEach(function (article) {
      var haystack = normalize(article.getAttribute('data-kb-search'));
      var isMatch = haystack.indexOf(query) !== -1;
      toggle(article, isMatch);
      if (isMatch) matches += 1;
    });

    if (resultCount) {
      resultCount.textContent = matches + (matches === 1 ? ' result' : ' results');
    }

    toggle(emptyState, matches === 0);
  }

  input.addEventListener('input', applySearch);
  input.addEventListener('change', applySearch);
  input.addEventListener('search', applySearch);

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      input.value = '';
      applySearch();
      input.focus();
    });
  }

  resetView();
}

function bootKnowledgeBaseSearch() {
  document.querySelectorAll('[data-knowledge-base]').forEach(initKnowledgeBase);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootKnowledgeBaseSearch);
} else {
  bootKnowledgeBaseSearch();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target && event.target.matches && event.target.matches('[data-knowledge-base]')) {
    initKnowledgeBase(event.target);
    return;
  }

  if (event.target && event.target.querySelectorAll) {
    event.target.querySelectorAll('[data-knowledge-base]').forEach(initKnowledgeBase);
  }
});